<template>
  <div class="button" @click="onClick">
    <img v-if="iconSrc" :src="iconSrc" :alt="label" />
    <span class="button-text">{{ label }}</span>
  </div>
</template>

<script setup>
import { defineEmits, defineProps } from "vue";

defineProps({
  label: String,
  iconSrc: String,
});

const emit = defineEmits(["click"]);

const onClick = () => {
  emit("click");
};
</script>

<style scoped>
.button {
  /* Figma */
  display: inline-flex;
  padding: 23px 38px;
  justify-content: center;
  align-items: center;
  gap: 15.503px;

  border-radius: 13.178px;
  background: var(--Brand);
  box-shadow: 1.55px 2.326px 1.783px 0px rgba(255, 255, 255, 0.4) inset,
    2.326px 2.326px 6.279px 0px rgba(0, 0, 0, 0.1);

  /* adaptions */
  cursor: pointer;
  user-select: none;
  box-sizing: border-box;
}

.button-text {
  /* overwrites */
  color: var(--Background);
}

.button:active {
  box-shadow: 1.55px 2.326px 8.6px 0px rgba(0, 0, 0, 0.4) inset;
}
</style>
